var map = {
	"./part-0_ovr.svg": "U2Ud",
	"./part-10_ovr.svg": "BxUb",
	"./part-11_ovr.svg": "T5Qm",
	"./part-12_ovr.svg": "CLsY",
	"./part-13_ovr.svg": "PBGB",
	"./part-14_ovr.svg": "mF7e",
	"./part-1_ovr.svg": "Ihds",
	"./part-2_ovr.svg": "NAY/",
	"./part-3_ovr.svg": "08MX",
	"./part-4_ovr.svg": "SnsQ",
	"./part-5_ovr.svg": "BHQJ",
	"./part-6_ovr.svg": "yLsD",
	"./part-7_ovr.svg": "y/zO",
	"./part-8_ovr.svg": "i8/x",
	"./part-9_ovr.svg": "7YFN"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uVes";